"use client";

import { useSyncExternalStore } from "react";

import { useTheme } from "next-themes";

// Client-mount detection via useSyncExternalStore. The server snapshot is `false`
// and the client snapshot is `true`, so the value flips to mounted right after
// hydration without calling setState inside an effect (which avoids hydration
// mismatch). The flag never changes afterwards, so the subscribe callback is a no-op.
const subscribeNoop = () => () => {
    /* no-op: the mounted flag never changes after hydration */
};
const getMountedClientSnapshot = () => true;
const getMountedServerSnapshot = () => false;

export function StatusBarTheme() {
    const { theme } = useTheme();

    // Avoid hydration mismatch: render the static status bar during SSR/hydration,
    // then the theme-dependent one once mounted on the client.
    const mounted = useSyncExternalStore(
        subscribeNoop,
        getMountedClientSnapshot,
        getMountedServerSnapshot
    );

    if (!mounted) {
        return (
            <>
                <meta name="apple-mobile-web-app-title" content="KwikNkap" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="black" />
            </>
        );
    }

    return (
        <>
            <meta name="apple-mobile-web-app-title" content="KwikNkap" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta
                name="apple-mobile-web-app-status-bar-style"
                content={theme === "dark" ? "black" : "default"}
            />
        </>
    );
}
